import { useSelector } from "react-redux";

/**
 * Hook to check if a feature flag is enabled
 * @param {string} featureKey - The key of the feature flag to check
 * @returns {boolean} - Whether the feature flag is enabled
 */
export const useFeatureFlag = (featureKey) => {
    const features = useSelector(state => state.features);
    
    // Check if features are initialized
    if (!features || !features.isInitialized) {
        return false;
    }
    
    // Check if the feature is active
    return Boolean(features.active[featureKey]);
};

/**
 * Hook to get multiple feature flags at once
 * @param {string[]} featureKeys - Array of feature keys to check
 * @returns {Object} - Object with feature keys as properties and boolean values
 */
export const useFeatureFlags = (featureKeys) => {
    const features = useSelector(state => state.features);
    
    if (!features || !features.isInitialized) {
        return featureKeys.reduce((acc, key) => {
            acc[key] = false;
            return acc;
        }, {});
    }
    
    return featureKeys.reduce((acc, key) => {
        acc[key] = Boolean(features.active[key]);
        return acc;
    }, {});
};
